<template>
  <div class="word-hunter-results-container rounded-big w-100 p-4 mt-4">
    <p class="font-weight-bold mb-3" v-if="selectedTopicId">{{ selectedTopic[0].name }}</p>
    <div class="mb-2" v-for="(keyword, key) in selectedWords" :key="key">
      <span class="pr-2" v-if="selectedMood(keyword.mood_id)">
        {{ selectedMood(keyword.mood_id) }}
      </span>
      {{ keyword.word }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "WordHunterResultsContainer",
  props: {
    selectedTopicId: Number,
    topicList: Array,
    selectedWords: Array,
  },
  computed: {
    ...mapGetters({
      moodsList: "moodsAndReactions/getMoodsList",
    }),
    selectedTopic() {
      return this.topicList.filter((topic) => {
        if (topic.id === this.selectedTopicId) {
          return topic;
        }
      });
    },
  },
  methods: {
    selectedMood(id) {
      if (id) {
        const mood = this.moodsList.moods.filter((mood) => {
          if (id === mood.id) {
            return mood;
          }
        });
        return mood[0].icon;
      }
      return "";
    },
  },
};
</script>
<style scoped lang="scss">
.word-hunter-results-container {
  background: $color-light;
  position: relative;
  &:after {
    content: "";
    width: 1.2rem;
    height: 1.5rem;
    display: block;
    position: absolute;
    top: -0.7rem;
    right: 2.2rem;
    background: $color-light;
    transform: rotate(45deg);
  }
}
</style>
